
/* ============================== src/components/discussion/CommentPolicy.js ============================== */
// path: frontend/src/components/discussion/CommentPolicy.js
/**
 * Доменный сервис UI-правил комментария. Не реализует RBAC: читает
 * серверные флаги из comment.permissions (CommentPermissions:
 * canEdit, canDelete, editableUntil), которые считает
 * domain/entity-permissions.ts::computeCommentPermissions.
 *
 * canEdit/canDelete — точное зеркало серверной проверки
 * (canEditComment/canDeleteComment). Сервер всё равно проверит при
 * PATCH/DELETE; клиент только скрывает кнопки.
 *
 * canPin() — заглушка: продуктового правила нет (на бэке CommentService.pin
 * не проверяет роль). Удалять/переносить нечего.
 *
 * getUserReaction — чисто UI: emoji, которым текущий пользователь
 * отреагировал (из comment.reactions). Это маппинг данных, не RBAC.
 */
export class CommentPolicy {
  constructor({ currentUser, comments = [] }) {
    this.currentUser = currentUser;
    this.comments = comments;
  }

  canEdit(c) {
    return Boolean(c?.permissions?.canEdit);
  }

  canDelete(c) {
    return Boolean(c?.permissions?.canDelete);
  }

  canPin() {
    return false;
  }

  static getUserReaction(comment, userId) {
    const reactions = comment.reactions || {};
    for (const [emoji, users] of Object.entries(reactions)) {
      if (users.includes(userId)) return emoji;
    }
    return null;
  }
}
